import axios from 'axios';
import { logger, clearSessionAndCookie } from '@marriott/shared/mi-helper-utils';
import { SESSION_TIMED_OUT_API } from './constants';

const handleSessionTimedOut = async (apiUrl: string, returnUrl?: string) => {
  return await axios
    .post(
      apiUrl,
      {
        returnTo: returnUrl,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(data => {
      clearSessionAndCookie();
      if (data?.data?.redirect) {
        window.location.href = data?.data?.nextStateURI;
      }
    })
    .catch(error => {
      const { log } = logger({})('SessionTimedOut');
      log.error('Session Timed Out failed', error);
    });
};

export const setupSessionTimeout = ({
  expiryTime,
  apiUrl = SESSION_TIMED_OUT_API,
}: {
  expiryTime?: string;
  apiUrl?: string;
}) => {
  const sessionExpiryTime = Number(expiryTime);
  if (sessionExpiryTime && sessionExpiryTime > 0) {
    clearTimeout(Number(expiryTime));
    window.setTimeout(async () => {
      const location = window?.location;
      const returnUrl = location?.pathname + location?.search + location?.hash;
      await handleSessionTimedOut(apiUrl, returnUrl);
    }, sessionExpiryTime);
  }
};
